module.exports = __webpack_public_path__ + "img/Villa_Borna_31.fb6e0146.jpg";